export default "__VITE_ASSET__76e42aOL__"